export default {
  laborContractFileUpload: "BackEnd/laborContractFileUpload",
  laborContractDeleteFile: "BackEnd/laborContractDeleteFile",
  signFileUpload: "BackEnd/signFileUpload",
  signDeleteFile: "BackEnd/signDeleteFile",
};
